import { IconButton, Tooltip } from "@mui/material";
import { Box } from "@mui/system";
import { useTranslation } from "react-i18next";
import { EditIcon } from "../../../assets/icons";

const EditButton = ({ handleEditClick }) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: { xs: "center", sm: "end" },
      }}
    >
      {/* edit */}
      <Tooltip title={t("patients_edit_modal_title")}>
        <span>
          <IconButton
            size="medium"
            sx={{
              height: "40px",
              color: "white",
            }}
            onClick={() => {
              handleEditClick();
            }}
          >
            <EditIcon />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};

export default EditButton;
